/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("CareerTabs", ["jquery", "Behaviors"], factory);
    } else {
        root.CareerTabs = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};
    function CareerTabs() {
        Behaviors.init(CareerTabs, this, arguments);
            
        this.$elem.find(CareerTabs.ELEMENTS.loadMoreButton).on("click", function(e){
        e.preventDefault();
        var $this = jQuery(this),
            tab = jQuery(this).parents('.CareerTabs-content_tabs_items_item');
            tab.find(".CareerTabs-content_tabs_items_item_posts_post:hidden").slice(0, 6).slideDown();
            if(tab.find(".CareerTabs-content_tabs_items_item_posts_post:hidden").length == 0) {
                $this.text("No more posts to load").addClass("CareerTabs-content_tabs_items_item_loadMore__button--noContent");
            }
        });

        var tabItem = this.$elem.find(CareerTabs.ELEMENTS.tabItemNav);
        var tabContent = this.$elem.find(CareerTabs.ELEMENTS.tabContentSection);
        this.$elem.find(CareerTabs.ELEMENTS.tabItemNav).on('click', function(e){
            e.preventDefault();
            var $this = jQuery(this);
            var href = jQuery(this).attr('href');
            var tab = jQuery(href);
            if(!$this.hasClass('is-CareerTabs-content_tabs_items_item--activeTab')) {
                tabContent.hide();
                tab.show();
                tabItem.removeClass('is-CareerTabs-content_tabs_nav_link--activeNav');
                $this.addClass('is-CareerTabs-content_tabs_nav_link--activeNav');
            }
        });
        
    }

    Behaviors.inherit(CareerTabs, Behaviors.Behavior);

    CareerTabs.QUERY = "[data-CareerTabs-tabs]";

    CareerTabs.ELEMENTS = {
        loadMoreButton: ".CareerTabs-content_tabs_items_item_loadMore__button",
        tabItemNav: ".CareerTabs-content_tabs_nav a",
        tabContentSection: ".CareerTabs-content_tabs_items_item",
    };
    
    Behaviors.register_behavior(CareerTabs);
    
    module.CareerTabs = CareerTabs;
    
    return module;
}));
